import React from 'react';
import {FormValidator} from '../../util/form-validator';
import {Modal} from "@mui/material";
import GieCard from "../../components/GIECard/GieCard";
import GIEButton from "../../components/GIEButton/GieButton";
import CloseIcon from "@material-ui/icons/Close";

export default class PopUpError extends React.Component<any, any> {
  formValidator: FormValidator = new FormValidator();

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      date: '',
      momentInday: 'matin',
      formControls: {
        email: {
          value: '',
          error: false,
          errorMessage: ''
        },
        mobile: {
          value: '',
          error: false,
          errorMessage: ''
        }
      }
    }
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      this.setState({open: this.props.open});
    }
  }

  closeModal() {
    this.props.closeModal();
  }

  render() {
    return (
      <Modal open={this.state.open} onClose={this.closeModal} aria-labelledby="modal-title">
        <GieCard width="500px" height="auto" className="center-absolute">
          <h4 id="modal-title" className="d-flex justify-content-between align-items-center">
            <span className="color-secondary">Une erreur s'est produite</span>
            <GIEButton onClick={this.closeModal}>
              <CloseIcon/>
            </GIEButton>
          </h4>
          <div className="text-center"
               dangerouslySetInnerHTML={{__html: this.props.text + "<br/>Merci de nous contacter directement pour modifier votre rendez-vous."}}>
          </div>
          <div className="text-center mt-4">
            <GIEButton onClick={this.closeModal} classes={{root: 'orange-btn'}} className="fw-bold">
              Confirmer
            </GIEButton>
          </div>
        </GieCard>
      </Modal>
    );
  }
}
